export enum SalesChannels {
  BILLBOARDWEB = 'BILLBOARDWEB',
  BILLBOARDMOBILE = 'BILLBOARDMOBILE'
}
